import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Select } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import {
  createPermission,
  getClusterResources,
  updatePermission,
} from '@/services/kopPermissionsService';
import { toTsOptions } from '@/utils/common';
import Form from '@/components/Form';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';
import { options } from '.';

const { FormItem } = Form;

function Modal({ handleClose, roleOptions, clusterName, visible, update, ...others }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const [resourceOptions, setResourceOptions] = useState([]);
  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });
  const isUpdate = !!update;

  const loadResourceOptions = useMemoizedFn(async () => {
    const { data = [] } = await getClusterResources({
      clusterName,
    });
    setResourceOptions(
      data.map((item) => ({
        label: item,
        value: item,
      })),
    );
  });

  useEffect(() => {
    if (visible) {
      loadResourceOptions();
      form.setFieldsValue(update);
    } else {
      form.resetFields();
    }
  }, [form, visible, loadResourceOptions, update]);

  const handleSubmit = async (fields) => {
    const request = isUpdate ? updatePermission : createPermission;

    try {
      setSubmitting(true);
      await request({ clusterName, type: 'topic', ...fields });

      handleClose(true);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  const doClose = () => handleClose();

  return (
    <Dialog
      header={isUpdate ? '修改权限' : '添加权限'}
      onCancel={doClose}
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      onCloseBtnClick={doClose}
      onEscKeydown={doClose}
      visible={visible}
      width={550}
      {...others}
    >
      <Form onFinish={handleSubmit} form={form} style={{ width: '80%', paddingBottom: 10 }}>
        <FormItem name='role' label='Role' rules={[{ required: true }]}>
          <Select
            options={toTsOptions(roleOptions)}
            disabled={isUpdate}
            placeholder='KopUser'
            clearable
          />
        </FormItem>
        <FormItem name='resource' label='选择资源' rules={[{ required: true }]}>
          <Select
            disabled={isUpdate}
            placeholder='请选择'
            filterable
            options={toTsOptions(resourceOptions)}
          />
        </FormItem>
        <FormItem name='permissions' label='权限' rules={[{ required: true }]}>
          <Select multiple placeholder='请选择' options={toTsOptions(options)} clearable />
        </FormItem>
      </Form>
    </Dialog>
  );
}

export default connect((state) => ({
  roleOptions: state.kopPermissions.roleOptions,
}))(Modal);
